import DOMPurify from 'dompurify'

const PurifiedHTML = ({ dom = '', html = '', ...rest }) => {
  const sanitizedHtml = DOMPurify.sanitize(html)
  DOMPurify.addHook('afterSanitizeAttributes', function (currentNode) {
    if (currentNode.tagName === 'A') {
      currentNode.setAttribute('target', '_blank')
      currentNode.setAttribute('rel', 'noopener')
    }
    return currentNode
  })

  switch (dom.toLowerCase()) {
    case 'p':
      return <p {...rest} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
    case 'div':
      return (
        <div {...rest} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
      )
    case 'li':
      return (
        <li {...rest} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
      )
    default:
      return (
        <span {...rest} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
      )
  }
}

export default PurifiedHTML
